import axios from "axios";

import SignOut from "../components/SignIn/SignOut";
const store = require("store");

const getAISDetails = async () => {
  const getAIS = `/ais`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3017 + getAIS,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const updateAISActionItem = async (params) => {
  const updateAIS = `/ais/actionItem`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "patch",
      url: process.env.REACT_APP_API_URL_3017 + updateAIS,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const addAISActionItem = async (params) => {
  const addAIS = `/ais/actionItem`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3017 + addAIS,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const deleteAISActionItem = async (item_seq) => {
  const deleteAIS = `/ais/actionItem/${item_seq}`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "delete",
      url: process.env.REACT_APP_API_URL_3017 + deleteAIS,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

export {
  getAISDetails,
  updateAISActionItem,
  addAISActionItem,
  deleteAISActionItem,
};
